import { useQuery } from "@tanstack/vue-query";
import type { ErrorType } from "@/custom-axios";
import { authCustomInstance } from "@/auth-custom-axios.ts";

type GlobalUserTenant = {
  id: string;
  active: boolean;
  slug: string;
};

export type CurrentGlobalUser = {
  id: number;
  emailAddress: string;
  tenants: GlobalUserTenant[];
};

export function useCurrentGlobalUserQuery() {
  return useQuery<CurrentGlobalUser, ErrorType<unknown>>({
    queryKey: ["currentGlobalUser"],
    queryFn: async () => {
      const response = await authCustomInstance<{ data: CurrentGlobalUser }>(
        "/api/auth/currentGlobalUser",
        {
          method: "GET",
        },
      );

      return response.data;
    },
  });
}
